/**
 * 资产相关路由
 */
export default [
  {
    path: "/assets",
    name: "assets",
    component: () => import("@/views/assets/index.vue")
  },
  {
    path: "/assetdetail/:id",
    name: "assetdetail",
    component: () => import("@/views/assets/_detail.vue")
  }
];
